function init() {

        // media and text block, vertical - make all same height within columns
        // edited to add the sbk schedule cards to have equal heights
        // Loop through each .wp-block-columns div
        function equalHeights() {
            jQuery('.wp-block-columns').each(function() {
                // Find all .wp-block-media-text__content divs within this wp-block-columns div
                var $mediaTextContents = jQuery(this).find('.media-text-vertical .wp-block-media-text__content');
                
                // If there are any .wp-block-media-text__content divs, proceed
                if ($mediaTextContents.length > 0 ) {
                    // Find the tallest .wp-block-media-text__content div
                    const columnCount = jQuery(this).children('.wp-block-column').length;

                    // only run if 3 or more columns
                    if (columnCount >= 3) {
                        $mediaTextContents.css('height', '');
                        var maxHeight = 0;
                        $mediaTextContents.each(function() {
                            
                            var contentHeight = jQuery(this).outerHeight();
                            if (contentHeight > maxHeight) {
                                maxHeight = contentHeight;
                            }
                        });
            
                        // Set the height of all .wp-block-media-text__content divs to the tallest one
                        $mediaTextContents.each(function() {
                            jQuery(this).outerHeight(maxHeight);
                        });

                        // set class for responsiveness
                        jQuery(this).addClass('tablet-friendly');
                    }
                    
                }

                // schedule cards or cover w/two cards
                if ( jQuery(this).hasClass('sbk-schedule-cards') || jQuery(this).parent().parent().hasClass('sbk-cover-two-column') ) {
                    var $scheduleCards = jQuery(this).find('.wp-block-sbk-card-simple');
                    $scheduleCards.css('height', '');
                    var maxSCHeight = 0;
                    $scheduleCards.each(function() {
                        var cardHeight = jQuery(this).outerHeight();
                        if (cardHeight > maxSCHeight) {
                            maxSCHeight = cardHeight;
                        }
                    });
                    $scheduleCards.each(function() {
                        jQuery(this).outerHeight(maxSCHeight);
                    })
                }

            });
        }

        let wwidth = jQuery(window).width();

        if ( wwidth > 600) {
            equalHeights();
        }

        jQuery(window).on('resize', function() {
            let wwidth = jQuery(window).width();

            if (wwidth > 600) {
                equalHeights();
            }
        });

}

export { init as default };